<template>
  <div class="block">
    <div class="delBtn" @click="showDeleteConfirm">
      删除
    </div>
    <a-col :span="8">
      <a-statistic title="名称" :value="data.name" v-if="data"> </a-statistic>
    </a-col>
    <a-col :span="8">
      <a-statistic title="电话" :value="data.phone" groupSeparator="" v-if="data"> </a-statistic>
    </a-col>
    <a-col :span="8">
      <a-statistic title="邮编" :value="data.postcode" v-if="data" groupSeparator=""> </a-statistic>
    </a-col>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { createVNode } from "vue";
import { Modal } from "ant-design-vue";

export default {
  data() {
    return {
      data: null
    };
  },
  created() {
    this.fetchDepartmentDetail();
  },
  methods: {
    ...mapActions("department", ["getDepartmentDetail", "deleteDepartment"]),
    async fetchDepartmentDetail() {
      const data = await this.getDepartmentDetail(this.$route.params.departmentId);
      this.data = data;
    },
    showDeleteConfirm() {
      Modal.confirm({
        title: "真的要删除吗？",
        icon: createVNode(ExclamationCircleOutlined),
        content: this.data.name,
        cancelText: "取消",
        okText: "确定",
        onOk: async () => {
          try {
            await this.deleteDepartment(this.data.id);

            this.$message.success("删除成功");
            this.$router.go(-1);
          } catch (error) {
            if (error.msg) {
              if (error.msg[0] === "FOREIGN KEY constraint failed") {
                this.$message.error("本科室还有报告，无法删除本科室");
              }
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.block {
  width: 100%;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 12px 23px 0px rgba(62, 73, 84, 0.04);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
}
.delBtn {
  position: absolute;
  right: 30px;
  top: 0;
  width: 40px;
  height: 50px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  padding: 9px 6px 23px 6px;
  cursor: pointer;
  background: url("../assets/delBtn.png");
  background-size: 40px 50px;
}
.ant-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .ant-statistic-title {
  color: #999;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}
::v-deep .ant-statistic-content {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #171b1e;
}
</style>
